// ──────────────────────────────────────────────
// React hooks for StorageService.
// Use useSyncExternalStore for tear-free reads.
// ──────────────────────────────────────────────

import { useSyncExternalStore } from 'react';

import type { StorageService } from './StorageService';
import type { StorageState } from './types';

// ── Fallback snapshot (returned when service is null) ──

const IDLE_STORAGE: StorageState = {
  status: 'uninitialized',
  backendType: null,
  isPersisted: false,
  error: null,
};

const noop = () => () => {};

/**
 * Subscribe to StorageService state.
 * Returns a static uninitialized state when service is null.
 */
export function useStorageState(service: StorageService | null): StorageState {
  return useSyncExternalStore(
    service ? (cb) => service.subscribe(cb) : noop,
    service ? () => service.getSnapshot() : () => IDLE_STORAGE,
  );
}
